var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconFeedback48(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Feedback48",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    opacity: 0,
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bounding-box",
    fillRule: "nonzero",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }), /*#__PURE__*/React.createElement("g", {
    id: "Speech-bubble",
    transform: "translate(6.750000, 12.000000)",
    stroke: "#1E1E1E"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.75,7 L33.75,20.96 C33.75,21.5122847 33.3022847,21.96 32.75,21.96 L29.3863636,21.96 L29.3863636,21.96 L29.35,27 L25.0227273,21.96 L10.75,21.96 C10.1977153,21.96 9.75,21.5122847 9.75,20.96 L9.75,7 C9.75,6.44771525 10.1977153,6 10.75,6 L32.75,6 C33.3022847,6 33.75,6.44771525 33.75,7 Z",
    id: "Speech-bubble-recieve",
    fill: "#FAEC20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.998304763 C0,0.446956267 0.44746922,0 1.00069463,0 L22.9993054,0 C23.5519738,0 24,0.448906158 24,0.998304763 L24,15.1555414 C24,15.7068899 23.5593879,16.1538462 22.9979137,16.1538462 L8.72727273,16.1538462 L4.4,21 L4.4,16.1538462 L0.998428106,16.1538462 C0.447011489,16.1538462 0,15.70494 0,15.1555414 L0,0.998304763 Z",
    fill: "#FFFFFF"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconFeedback48);
export default __webpack_public_path__ + "static/media/pictogramBeaconFeedback48.f985e05c35fc739ab744385fe4f12f1c.svg";
export { ForwardRef as ReactComponent };